<script lang="ts">
  // An NJ Transit route badge: BusRouteBadge (bjl Badge) in NJ Transit blue, printing the
  // public route number. Its own component only because the label MUST come through
  // `routeBadgeLabel` — the route id (`NJB-12`) is not the number on the bus (`113`) — and
  // that lookup is only answered once store/njbus has registered the network, so callers
  // re-key this on the network the way RouteBullet does.
  import BusRouteBadge from './BusRouteBadge.svelte'
  import { routeBadgeLabel } from '../ui/colors'

  interface Props {
    routeId: string
    size?: 'xs' | 'sm' | 'md'
  }

  const { routeId, size = 'sm' }: Props = $props()
</script>

<BusRouteBadge {routeId} label={routeBadgeLabel(routeId)} {size} />
